import React from "react";
import { NoTranslate } from "../Common/NoTranslate";

interface ContentLengthCounterProps {
    value: string;
    maxLength?: number;
}

export const ContentLengthCounter = ({ value, maxLength }: ContentLengthCounterProps) => {
    return maxLength ? (
        <span className="text-sm text-gray-dark" data-testid="content-length-counter">
            <NoTranslate>
                {value?.length}/{maxLength}
            </NoTranslate>
            &nbsp; | <var data-var="wordsCount">{getSentenceLength(value)}</var> words
        </span>
    ) : (
        <span className="text-sm text-gray-dark">
            <var data-var="charactersCount">{value?.length} characters</var> |&nbsp;
            <var data-var="wordsCount">{getSentenceLength(value)}</var> words
        </span>
    );
};

const getSentenceLength = (value: string) => value?.split(/\s+/).filter((x) => x.trim().length > 0).length;
